import React from 'react';
import { BookOpen as LucideBookOpen } from 'lucide-react';

interface BookOpenProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const BookOpen: React.FC<BookOpenProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideBookOpen width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default BookOpen;
